import { otpResend, submitContactForm, submitOtpForm } from "actions/editor";
import { useRef } from "react";
import { useDispatch } from "react-redux";

export const useFormActions = () => {
  const dispatch = useDispatch();
  const ref = useRef();

  if (!ref.current) {
    ref.current = {
      onFormSubmit: (editorSession, formId) =>
        dispatch(submitContactForm(editorSession, formId)),
      onOtpFormSubmit: (editorSession, formId) =>
        dispatch(submitOtpForm(editorSession, formId)),
      onOtpResend: (editorSession, formId) =>
        dispatch(otpResend(editorSession, formId)),
    };
  }

  return ref.current;
};
